import React from "react"
import { observer } from "mobx-react-lite"

export interface MarketFilterContextData {
  /** Selected market country names. Empty = all markets (SuperAdmin only). */
  countries: string[]
  setCountries: (value: string[]) => void
  /** When true, market filter is locked to the user's own country. */
  locked: boolean
}

export const MarketFilterContext =
  React.createContext<MarketFilterContextData | null>(null)

export type Props = {
  value: string[]
  locked?: boolean
  onChange: (value: string[]) => void
}

export const MarketFilterContextProvider: React.FC<Props> = observer(
  ({ value, locked = false, onChange, children }) => {
    const context: MarketFilterContextData = React.useMemo(
      () => ({
        countries: value,
        setCountries: onChange,
        locked,
      }),
      [value, onChange, locked]
    )

    return (
      <MarketFilterContext.Provider value={context}>
        {children}
      </MarketFilterContext.Provider>
    )
  }
)

export const useMarketFilterContext = () => {
  const ctx = React.useContext(MarketFilterContext)
  if (!ctx) {
    throw new Error(
      "useMarketFilterContext must be used within MarketFilterContextProvider"
    )
  }
  return ctx
}
